import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dev-panel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_ctx.isDev)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          icon: "settings",
          onClick: _ctx.togglePanel,
          variant: "plain",
          color: "text-primary"
        }, null, 8, ["onClick"]),
        _createVNode(_component_v_overlay, {
          modelValue: _ctx.isPanelOpen,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isPanelOpen) = $event)),
          class: "dev-overlay"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "dev-card" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _ctx.togglePanel,
                  class: "close",
                  icon: "close",
                  color: "text-primary",
                  variant: "text",
                  density: "compact"
                }, null, 8, ["onClick"]),
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("Developer Tools")
                  ])),
                  _: 1
                }),
                (_ctx.error)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      type: "error",
                      class: "mb-4"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(`errors.${_ctx.error}`)), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: "error",
                      onClick: _ctx.resetStore
                    }, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode(" Reset Store ")
                      ])),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      color: "success",
                      loading: _ctx.isCreating,
                      disabled: _ctx.isCreating,
                      onClick: _ctx.createFakeAccount
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode(" Create Test Account ")
                      ])),
                      _: 1
                    }, 8, ["loading", "disabled", "onClick"]),
                    _createVNode(_component_v_btn, {
                      color: "on-surface",
                      onClick: _ctx.togglePanel
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode(" Close ")
                      ])),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]))
    : _createCommentVNode("", true)
}